<template>
    <h2 class="mt-0">Badges</h2>

    <h3>Active</h3>
    <DsBadge
        text="Active"
        variant="active"
    />

    <h3>Inactive</h3>
    <DsBadge
        text="Inactive"
        variant="inactive"
    />

    <h3>Success</h3>
    <DsBadge
        text="Success"
        variant="success"
    />

    <h3>Warning</h3>
    <DsBadge
        text="Warning"
        variant="warning"
    />

    <h3>Error</h3>
    <DsBadge
        text="Error"
        variant="error"
    />
    <h3>With tooltip</h3>
    <DsBadge
        text="With tooltip"
        tooltipText="verything worked out great"
        variant="success"
    />

    <h3>In context</h3>
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Status</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Muhammad Ali</td>
                <td>One Two Punch, Louisville, KY 40018</td>
                <td>
                    <DsBadge
                        text="Final Count"
                        variant="inactive"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Craig Biggio</td>
                <td>6418 Brompton St, Houston, TX 77005</td>
                <td>
                    <DsBadge
                        text="Astros"
                        variant="active"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Alex Morgan</td>
                <td>2024 Gooooooooooal Rd, San Diego, CA 91911</td>
                <td>
                    <DsBadge
                        text="Gold Medalist"
                        variant="warning"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Barry Allen</td>
                <td>West House, Earth-1</td>
                <td>
                    <DsBadge
                        text="Very fast"
                        variant="success"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Kennedy Space Center</td>
                <td>T - 5</td>
                <td>
                    <DsBadge
                        text="Launch imminent"
                        variant="error"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
        </tbody>
    </table>

    <h2 class="mt-8 border-t pt-8">Shared Components</h2>

    <h3 class="mb-2">Insurance Badge (Default)</h3>
    <div class="flex gap-4">
        <InsuranceBadge.Default :insurance="Insurance.INSURANCE_INSURED" />
        <InsuranceBadge.Default :insurance="Insurance.INSURANCE_PENDING" />
        <InsuranceBadge.Default :insurance="Insurance.INSURANCE_NOT_INSURED" />
    </div>

    <h3 class="mb-2">Insurance Badge (BAV)</h3>
    <div class="flex gap-4">
        <InsuranceBadge.Bav
            context="report"
            :insurance="Insurance.INSURANCE_INSURED"
        />
        <InsuranceBadge.Bav :insurance="Insurance.INSURANCE_ACTION_REQUIRED" />
    </div>
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/DsBadge.vue';
import InsuranceBadge from '@/components/shared/InsuranceBadge';
import { Insurance } from '@/types/closinglock.types.js';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>

<style lang="scss" scoped>
h3,
table {
    margin-top: 1em;
}

table {
    tr:nth-child(even) {
        @apply bg-ds-primary-50;
    }

    th,
    td {
        padding: 0.25em 0.75em;
    }
}
</style>
